import axios from "axios"

export const indonesiaRegionService = {
  getProvinces: async () => {
    const { data } = await axios.get("https://www.emsifa.com/api-wilayah-indonesia/v2/provinces.json")
    return data?.data?.map(e => ({ id: e.id, name: e.name }))
    // const { data } = await axios.get("https://alamat.thecloudalert.com/api/provinsi/get")
    // return data?.result.map(e => ({ id: e.id, name: e.text }))
  },
  getCities: async () => {
    const { data } = await axios.get("https://www.emsifa.com/api-wilayah-indonesia/v2/regencies/31.json")
    return data?.data?.map(e => ({ id: e.id, name: e.name.replace("Administrasi ", "").replace("Kabupaten ", "") }))
    // const { data } = await axios.get("https://alamat.thecloudalert.com/api/kabkota/get/?d_provinsi_id=6")
    // return data?.result.map(e => ({ id: e.id, name: e.text }))
  },
  getDistricts: async (id) => {
    const { data } = await axios.get(`https://www.emsifa.com/api-wilayah-indonesia/v2/districts/${id}.json`)
    return data?.data?.map(e => ({ id: e.id, name: e.name }))
    // const { data } = await axios.get("https://alamat.thecloudalert.com/api/kecamatan/get/?d_kabkota_id="+id)
    // return data?.result.map(e => ({ id: e.id, name: e.text }))
  },
  getSubdistricts: async (id) => {
    const { data } = await axios.get(`https://www.emsifa.com/api-wilayah-indonesia/v2/villages/${id}.json`)
    return data?.data?.map(e => ({ id: e.id, name: e.name }))
    // const { data } = await axios.get("https://alamat.thecloudalert.com/api/kelurahan/get/?d_kecamatan_id="+id)
    // return data?.result.map(e => ({ id: e.id, name: e.text }))
  },
}